import PermanentStorage from "../../storage";
const shortcutStorage = new PermanentStorage("FTLShortcutUtils_");
const normalizeKey = shortcutStorage.getKey.bind(shortcutStorage);
export const FTLShortcutUtils = Object.freeze({
    /**
     * @returns Массив всех ключей из PermanentStorage с префиксом FTLShortcutUtils_
     */
    get shortcuts() {
        const shortcuts = {};
        shortcutStorage.rawKeys().forEach((key) => {
            shortcuts[key] = FTLShortcutUtils.getShortcut(key);
        });
        return shortcuts;
    },
    get shortcutKeys() {
        return shortcutStorage.rawKeys();
    },
    get shortcutNormalizedKeys() {
        return shortcutStorage.keys();
    },
    normalizeKey,
    getShortcut: (
    /**
     * Ключ здесь нужно писать с префиксом FTLShortcutUtils_ или использовать для нормализации FTLShortcutUtils.normalizeKey
     */
    rawKey) => {
        return shortcutStorage.rawGet(rawKey);
    },
    setShortcut: (
    /**
     * Ключ здесь нужно писать с префиксом FTLShortcutUtils_ или использовать для нормализации FTLShortcutUtils.normalizeKey
     */
    rawKey, newValue) => {
        const item = FTLShortcutUtils.getShortcut(rawKey);
        if (item) {
            const newValueNormalized = typeof newValue === "function" ? newValue(item) : newValue;
            const newItem = Object.assign(Object.assign({}, item), newValueNormalized);
            shortcutStorage.rawSet(rawKey, newItem);
            return newItem;
        }
        return null;
    },
    register: (key, { default: defaultCode, label, current, }) => {
        if (!shortcutStorage.get(key)) {
            shortcutStorage.set(key, {
                default: defaultCode,
                label,
                current: current || defaultCode,
            });
        }
        return localStorage;
    },
    clear: shortcutStorage.clear.bind(shortcutStorage),
    reset: () => FTLShortcutUtils.shortcutKeys.forEach((key) => FTLShortcutUtils.setShortcut(key, (item) => ({ current: item.default }))),
    getKeyCode: (key) => { var _a, _b; return (_b = (_a = FTLShortcutUtils.getShortcut(normalizeKey(key))) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null; },
    setKeyCode: (key, code) => FTLShortcutUtils.setShortcut(normalizeKey(key), {
        current: code,
    }),
    getLabel: (key) => { var _a, _b; return (_b = (_a = FTLShortcutUtils.getShortcut(normalizeKey(key))) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : null; },
    setLabel: (key, label) => FTLShortcutUtils.setShortcut(normalizeKey(key), { label }),
    getDefault: (key) => { var _a, _b; return (_b = (_a = FTLShortcutUtils.getShortcut(normalizeKey(key))) === null || _a === void 0 ? void 0 : _a.default) !== null && _b !== void 0 ? _b : null; },
    setDefault: (key, defaultCode) => FTLShortcutUtils.setShortcut(normalizeKey(key), {
        default: defaultCode,
    }),
});
export default FTLShortcutUtils;
//# sourceMappingURL=index.js.map